
import userMixin from '~/mixins/users/userMixin'

export default {
  mixins: [
    userMixin
  ],
  props: {
    user: {
      type: Object,
      default () {
        return {}
      },
      required: true
    },
    size: {
      type: String,
      default: 'lg'
    }
  },

  computed: {
    minsDiff () {
      let mDiff = 0

      if (!!this.user && !!this.user.last_active) {
        const cDate = new Date()
        const uDate = new Date(this.user.last_active)

        mDiff = Math.floor(Math.abs(cDate.getTime() - uDate.getTime()) / 60000)
      }

      return mDiff
    }
  }
}
